export default {
  section_title: 'Valuta',
  label: 'Valuta',
  tooltip:
    'Den valuta, som dine priser, udbetalinger og rapporter bruger. Den indstilles, når din partnerkonto oprettes, og kan ikke ændres her – kontakt support, hvis den er forkert.',
  from_your_partner: 'Fra din partner',
  set_for_your_account: 'Indstillet for din konto',
};
